<div class="container-xl" [appStoryblok]="_editable">
  <div class="row">
    <div class="col-lg-4 order-3 order-lg-0">
      <div class="menu d-none d-lg-flex" *ngFor="let child of menu">
        <ndc-dynamic
          *ngIf="components && child?.content?.component"
          [ndcDynamicComponent]="components[child?.content?.component]"
          [ndcDynamicInputs]="child.content"
        >
        </ndc-dynamic>
      </div>
    </div>
    <div class="col-lg-7">
      <h1 class="mb-5">{{ title }}</h1>
      <ng-container *ngFor="let blok of content">
        <ndc-dynamic
          *ngIf="components && blok.component"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </ng-container>
    </div>
  </div>
</div>
